import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const shipmentId = new URLSearchParams(window.location.search).get("shipment_id");
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mx-auto max-w-lg px-4 py-20 text-center" data-testid="payment-cancel-page">
        <XCircle className="mx-auto h-14 w-14 text-muted-foreground" />
        <h1 className="mt-5 font-heading font-extrabold text-3xl">{t("pay.cancelTitle")}</h1>
        <p className="mt-3 text-muted-foreground">{t("pay.cancelDesc")}</p>
        <Button data-testid="back-to-shipment-btn" className="mt-8 rounded-sm bg-primary text-white"
          onClick={() => navigate(shipmentId ? `/shipments/${shipmentId}` : "/dashboard")}>
          {t("pay.backDash")}
        </Button>
      </div>
    </div>
  );
}
